import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { fontSizeCaption1 } from '../typography'

export const createMuiBottomNavigation = ({ palette, misc }: Pick<Tokens, 'palette' | 'misc'>) => ({
  MuiBottomNavigation: {
    styleOverrides: {
      root: {
        boxShadow: 'none',
        borderTop: misc.borderStyle('divider', 1),
        backgroundColor: palette.background.paper,
      },
    },
  },
  MuiBottomNavigationAction: {
    styleOverrides: {
      root: {
        minWidth: 0,
        maxWidth: 'none',
        transition: 'none',
        padding: spacing(0, 0.5),
        borderRadius: '50%',

        ...misc.createHoverOrActiveState({
          backgroundColor: palette.grey[200],
          outline: `${misc.borderSize(3)} solid ${palette.background.paper}`,
          outlineOffset: `-${misc.borderSize(3)}`,
          borderRadius: spacing(10),
        }),

        ...misc.createFocusVisibleState({
          outline: `${misc.borderSize(3)} solid ${palette.background.paper}`,
          outlineOffset: `-${misc.borderSize(3)}`,
          borderRadius: spacing(10),
        }),

        '& .MuiSvgIcon-root': {
          width: spacing(3),
          height: spacing(3),
        },

        '& .MuiBottomNavigationAction-label': {
          // Enforce the font family for the label, when using the @dhl-ui/connector this fontFamily
          // will be reset to the default MUI fontFamily, so we need to enforce it here
          //
          // TODO(JIRA-#DS-53): Remove this after the @dhl-ui/connector is no longer needed and apps import
          // it straight from @dhl-ui/components
          fontFamily: '"Delivery Regular", Calibri, Arial, sans-serif',
          fontSize: fontSizeCaption1,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '100%',
          color: palette.text.secondary,

          '&.Mui-selected': {
            fontSize: fontSizeCaption1,
          },
        },

        '&.Mui-selected': {
          color: palette.primary.notContained,

          '.MuiBottomNavigationAction-label': {
            fontWeight: 'bold',
            color: palette.primary.notContained,
          },
        },

        '& .MuiBadge-badge': {
          transform: 'scale(1) translate(50%, -38%)',
        },
      },
    },
  },
})
